import React, { useEffect } from "react"

declare global {
  interface Window {
    dataLayer?: IArguments[]
    gtag?: (...args: unknown[]) => void
  }
}

interface GoogleAnalytics4LoaderProps {
  enabled: boolean
}

/**
 * Loads GA4 only after cookie consent (BRD: analytics after acceptance).
 * Measurement ID is provided per environment via deployment variables.
 */
export const GoogleAnalytics4Loader: React.FC<GoogleAnalytics4LoaderProps> = ({
  enabled,
}) => {
  useEffect(() => {
    if (!enabled) return

    const measurementId = import.meta.env.VITE_GA4_MEASUREMENT_ID?.trim()
    if (!measurementId) return

    const existing = document.getElementById("evoly-ga4-loader")
    if (existing) return

    window.dataLayer = window.dataLayer ?? []
    // Must use `arguments` (not rest params) — GA4 only recognises Arguments
    // objects as gtag commands; plain arrays are silently ignored.
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer!.push(arguments as unknown as IArguments)
    }

    // Queue initialisation commands BEFORE the script loads so GA4 finds
    // them in dataLayer on startup (standard GA4 snippet pattern).
    window.gtag("js", new Date())
    window.gtag("config", measurementId)

    const script = document.createElement("script")
    script.id = "evoly-ga4-loader"
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
    document.head.appendChild(script)

    return () => {
      script.remove()
      delete window.gtag
    }
  }, [enabled])

  return null
}
